import Session from '../../utils/Session';
import { Capability } from '../account';
import ServiceType from './ServiceType.enum';

/**
 * Configuration for services that should be blocked based on a specific condition.
 * Each entry maps a carrier rule to the list of service types that should be filtered.
 */
export const BlockedServicesConfig = {
	fedexReseller: {
		// Services blocked for users without FedEx user-owned accounts
		serviceTypes: [
			ServiceType.FedExFirstOvernight,
			ServiceType.FedExPriorityOvernight,
			ServiceType.FedExStandardOvernight,
			ServiceType.FedEx2DayAm,
			ServiceType.FedExExpressSaver,
			ServiceType.FedExGround,
			ServiceType.FedExHomeDelivery,
			ServiceType.FedExIntlFirst,
			ServiceType.FedExIntlPriority,
			ServiceType.FedExIntlEconomy,
			ServiceType.FedExIntlGround,
		],
		shouldBlock: () => {
			const accountInfo = Session.getAccountInfo();
			const isArray = Array.isArray(accountInfo.configuredCarriers);
			const configuredCarriers = isArray ? accountInfo.configuredCarriers : [];

			const hasFedExWithoutUserOwnedAccount = configuredCarriers.some(
				carrier =>
					carrier.carrier === 'fedex' && carrier.userOwnedAccount === false
			);

			return hasFedExWithoutUserOwnedAccount;
		},
	},
};
